import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControl from '@material-ui/core/FormControl';
import noop from 'lodash/noop';
import { shallowEqual } from 'app-source/utils/shallowEqual';
import { TriviaChoiceComponent } from './Choice';

export class TriviaChoicesComponent extends Component {
  static propTypes = {
    title: PropTypes.string,
    choices: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      }),
    ),
    handleChoiceSelect: PropTypes.func,
    disabled: PropTypes.bool,
    selectedValue: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    choices: [],
    disabled: false,
    selectedValue: null,
    handleChoiceSelect: noop,
  };

  shouldComponentUpdate(nextProps, nextState) {
    return !shallowEqual(this, nextProps, nextState, {
      propsSelectOptions: { omit: ['handleChoiceSelect'] },
    });
  }

  render() {
    const { choices, title, disabled, selectedValue, handleChoiceSelect } = this.props;

    return (
      <FormControl fullWidth margin="normal" component="fieldset" required>
        <RadioGroup aria-label={title} name="trivia_choices" value={selectedValue}>
          {choices.map(({ label, value, isCorrect }) => (
            <TriviaChoiceComponent
              key={`${label}-${value}`}
              label={label}
              value={value}
              disabled={disabled}
              selectedValue={selectedValue}
              isCorrect={isCorrect}
              handleChoiceSelect={handleChoiceSelect}
            />
          ))}
        </RadioGroup>
      </FormControl>
    );
  }
}
